import { FuelTypography, FuelButton, FuelGridContainer, FuelGridItem } from '@frete.com/fuel-react'
import * as Styled from '../../styled'
import { date } from '~utils/date'
import { money } from '~utils/money'
import { lastDayOfMonth } from 'date-fns'
import { CalloutConsumptionProps } from './interfaces'

const expirationDate = date(lastDayOfMonth(new Date()).toISOString(), 'dd/MM/yy')

const CalloutConsumption = ({ invoice, value, onClickSeeInvoice }: CalloutConsumptionProps) => {
  const dueDate = invoice === null ? expirationDate : date(invoice.due_date, 'dd/MM/yyyy')
  const isExpired = !!invoice

  return (
    <Styled.InvoiceWrapper isExpired={isExpired}>
      <FuelGridContainer style={{ margin: 0, width: '100% ' }}>
        <FuelGridItem xlg={6} md={6} lg={6} sm={4}>
          <FuelTypography size="body-sm" weight="bold" color="neutral-strong">
            {isExpired ? 'Sua fatura de extras fechou!' : 'Valor parcial da fatura de extras'}
          </FuelTypography>
          <FuelTypography size="caption" color="neutral-strong">
            {isExpired ? 'Pague até ' : 'Fecha em'} {dueDate}
          </FuelTypography>
        </FuelGridItem>
        <FuelGridItem xlg={6} md={6} lg={6} sm={4} style={{ textAlign: 'right' }}>
          {isExpired ? (
            <FuelButton
              variant="secondary"
              onClick={onClickSeeInvoice}
              size="large"
              data-testid="consumption-card-callout-see-invoice"
            >
              Ver fatura
            </FuelButton>
          ) : (
            <FuelTypography size="body-sm" weight="bold" data-testid="consumption-card-callout-value-invoice">
              {money(value)}
            </FuelTypography>
          )}
        </FuelGridItem>
      </FuelGridContainer>
    </Styled.InvoiceWrapper>
  )
}

export default CalloutConsumption
